import React from 'react'
import { Tooltip } from 'antd'
import { useIntl } from 'react-intl'

interface INoPermissionTooltipProps {
  children: React.ReactElement
}

const NoPermissionTooltip = ({ children }: INoPermissionTooltipProps): React.ReactElement => {
  const { formatMessage } = useIntl()

  return <Tooltip title={formatMessage({ id: 'app.noPermission' })}>{children}</Tooltip>
}

export default NoPermissionTooltip
